import { createFileRoute, useParams } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { useState } from 'react';
import { ConfirmActionDialog } from '@/components/Dialog/ConfirmActionDialog';
import { VStack } from '@/components/Layout';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';
import { defaultNS, useTranslation } from '@/lib/i18n';
import EditPlanDialog from './-components/EditPlanDialog';
import { PlanHeader } from './-components/Header';
import PlanHeaderSkeleton from './-components/HeaderSkeleton';
import RestructuringChart from './-components/RestructuringChart';
import RestructuringChartSkeleton from './-components/RestructuringChartSkeleton';
import { useCompleteDepartmentRestructuring } from './-query';
import { useRestructuringChartData } from './-useRestructuringChartData';
import { PlanDetailSearchSchema } from './-zod-schema';
export const Route = createFileRoute('/_staff/organization/plan/$id/')({
  component: RouteComponent,
  validateSearch: zodValidator(PlanDetailSearchSchema),
  loaderDeps: ({
    search
  }) => ({
    search
  })
});
function RouteComponent() {
  const {
    id
  } = useParams({
    from: '/_staff/organization/plan/$id/'
  });
  const {
    detail,
    organizations,
    isLoading,
    initialCollapsed,
    onCollapsedChange
  } = useRestructuringChartData(id);
  const completeMutation = useCompleteDepartmentRestructuring(id);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [isApproveConfirmOpen, setIsApproveConfirmOpen] = useState(false);
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.organization.plan.detailPage'
  });
  const tc = useCommonTranslation();
  const handleEdit = () => {
    setIsEditOpen(true);
  };
  const handleApprove = () => {
    setIsApproveConfirmOpen(true);
  };
  const handleConfirmApprove = () => {
    if (!detail) return;
    setIsApproveConfirmOpen(false);
    completeMutation.mutate({
      version: detail.version
    });
  };
  if (isLoading || !detail) {
    return <VStack className="gap-4">
        <PlanHeaderSkeleton />
        <div className="px-12 py-5">
          <RestructuringChartSkeleton />
        </div>
      </VStack>;
  }
  return <VStack className="gap-4">
      <PlanHeader data={detail} onEdit={handleEdit} onApprove={handleApprove} isApproving={completeMutation.isPending} />

      <RestructuringChart organizations={organizations} status={detail.status} initialCollapsed={initialCollapsed} onCollapsedChange={onCollapsedChange} />

      <EditPlanDialog isOpen={isEditOpen} onClose={() => setIsEditOpen(false)} data={detail} />
      <ConfirmActionDialog isOpen={isApproveConfirmOpen} onClose={() => setIsApproveConfirmOpen(false)} onConfirm={handleConfirmApprove} title={{
      resource: detail.name,
      action: tc('action.approve')
    }} description={t('completeDialog.description')} okLabel={tc('action.approve')} />
    </VStack>;
}